import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLoader } from '../../../../../helpers/useLoader';
import { IClarificationsStore } from '../Clarifications.store';
import { ClarifyModal } from '../components/ClarifyModal';
import { IClarificationsBl } from '../services/Clarifications.bl';

interface IProps {
  showModal: boolean;
  onToggle(): void;
}

export const ClarifyModalContainer = observer((props: IProps): ReactElement => {
  const { clarification } = useInjection(IClarificationsStore.$);
  const clarificationsBl = useInjection(IClarificationsBl.$);

  const { projectId } = useParams<{ projectId: string }>();
  const [answer, setAnswer] = useState<string>('');
  const { withLoaderAsync } = useLoader();

  const handleToggle = (): void => {
    setAnswer('');
    props.onToggle();
  };

  const handleSaveClarificationAnswer = async (): Promise<void> => {
    if (clarification) {
      handleToggle();

      await withLoaderAsync(async () => {
        if (!clarification) {
          throw 'clarification can not be empty';
        }

        await clarificationsBl.clarifyAsync(projectId, clarification.clarificationId, answer);
      }, 'answer-clarification-button');
    }
  };

  const handleAnswerChange = (value: string): void => {
    setAnswer(value);
  };

  return (
    <>
      {clarification && (
        <ClarifyModal
          showModal={props.showModal}
          clarification={clarification}
          answer={answer}
          onToggleChange={handleToggle}
          onAnswerChange={handleAnswerChange}
          onSaveClarificationAnswer={handleSaveClarificationAnswer}
        />
      )}
    </>
  );
});
